var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offers-page"},[_c('div',{staticClass:"offers-page-header"},[_c('offers-page-header')],1),_c('div',{staticClass:"offers-body"},[_c('offers-body')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }